import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initFilterPosts() {

    setTimeout(function () {
        let page_navi = 0;
        if ($('.section-filter-posts .posts .wp-pagenavi').outerHeight()) {
            let page_navi = $('.section-filter-posts .posts .wp-pagenavi').outerHeight(true);
        }

        let height = $('.section-filter-posts').height() - ($('.section-filter-posts .filter .in').height() + $('.section-filter-posts .filter .in h2').outerHeight(true) + 31 + page_navi);

        ScrollTrigger.matchMedia({
            // desktop
            "(min-width: 768px)": function () {
                gsap.to(".section-filter-posts .filter .in", {
                    scrollTrigger: {
                        trigger: ".section-filter-posts .filter .in",
                        pin: true,
                        start: "top 38%", // when the top of the trigger hits the top of the viewport
                        end: () => '+=' + height,
                        scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                        invalidateOnRefresh: true,
                        markers: false,
                    }
                });
            },
        })
    }, 500)
}

export function initFilterPostsSection() {
    initFilterPosts();
}